import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { keyframes, ThemeProvider } from '@mui/material/styles';
import { theme } from '../../theme';
import HeaderProfile from '../../components/header_Profile/header_Profile.index';
import OocyteRetrieval from '../../components/Surgery/oocyteRetrieval';
import EmbryoTransfer from '../../components/Surgery/embryoTransfer';
// import Laparoscopy from '../../components/Surgery/laparoscopy';
// import Hysteroscopy from '../../components/Surgery/hysteroscopy';
// import SurgicalSpermRetrieval from '../../components/Surgery/surgicalSpermRetrieval';
import { ReactComponent as UterusIcon } from '../../assets/SVG/uterus1.svg';
import { ReactComponent as EmbryoIcon } from '../../assets/SVG/embryo1.svg';
import { ReactComponent as LaparoscopyIcon } from '../../assets/SVG/laparoscopy1.svg';
import { ReactComponent as HysteroscopyIcon } from '../../assets/SVG/hysteroscopy1.svg';
import { ReactComponent as SpermRetrievalIcon } from '../../assets/SVG/sperm1.svg';
import { usePatientContext } from '../../components/patinetProvider';
import { fetchMasterData, getARTCycleList } from '../../components/Surgery/oocyteRetrieval/OocyteRetrival.helper';
import { useLoader } from '../../components/loaderProvider/loader';
import CyclesUnavailable from '../../components/Surgery/cyclesUnavailable';
import LaparoscopyContainer from '../../components/Surgery/laparoscopy/LaparoscopyContainer';
import HystereoscopyContainer from '../../components/Surgery/hysteroscopy/hysteroscopyContainer';
import SurgicalSpermRetrievalContainer from '../../components/Surgery/surgicalSpermRetrieval/surgicalSpermRetrievalContainer';
import { usePatientContext as useSubPatientContext } from '../../components/SubPatinetProvider';
import PrintButton from '../Registration/NewRegistration/PatientPartnerRegistration/PatientReport/PrintButton';
import OocyteRetrievalPDFDialog from '../Registration/NewRegistration/PatientPartnerRegistration/PatientReport/OocyteRetrievalPDFDialog';
import EmbryoTransferPDFDialog from '../Registration/NewRegistration/PatientPartnerRegistration/PatientReport/EmbryoTransferPDFDialog';
import { DropdownOption, mapDropdownOptions } from '../../components/Medical_History_Forms/MenstrualHistory/MenstrualHistory.helpers';



// Interface for patient data
interface PatientData {
  id: number;
  gender: 'MALE' | 'FEMALE';
  age: number;
  nameTitle: string;
  firstName: string;
  lastName: string;
  cycleNo: string;
  mrNo: string;
  updatedDatetime: Date;
  LastModified: string;
  visitID: string;
  genderId: string;
  visitedDoctorID: string;
  therapyId: string;
};

const SurgeryPage: React.FC = () => {
  const [selectedPatient, setSelectedPatient] = useState<PatientData | null>(null);
  const [selectedProcedure, setSelectedProcedure] = useState<string>('OocyteRetrieval');

  const { patientId } = usePatientContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [cycleExists, setCycleExists] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const { patientId: selected_PID } = useSubPatientContext();
  const [openPreview, setOpenPreview] = useState(false);
  const [dropdownOptionsForSurgery, setDropdownOptionsForSurgery] = useState<{
    type_of_anesthesia: DropdownOption[];
    type_of_needle: DropdownOption[];
    sub_type_of_needle: DropdownOption[];
    difficulty_level: DropdownOption[];
    transfer_method: DropdownOption[];
    embryo_Anesthesia: DropdownOption[];
    endometrium_pattern: DropdownOption[];
    ultrasound_method: DropdownOption[];
    catheter: DropdownOption[];
    embryoDifficulty_level: DropdownOption[];
    Laparo_anesthesia_type: DropdownOption[];
    adhesion_grade: DropdownOption[];
    endometriosis_grade: DropdownOption[];
    uterus_status: DropdownOption[];
    uterus_size: DropdownOption[];
    uterus_mobility: DropdownOption[];
    associated_procedures: DropdownOption[];
    liver_undersurface: DropdownOption[];
    cavity:DropdownOption[],
    endometrium_patterns: DropdownOption[],
    procedure_done: DropdownOption[],

  }>({
    type_of_anesthesia: [],
    type_of_needle: [],
    sub_type_of_needle: [],
    difficulty_level: [],
    transfer_method: [],
    embryo_Anesthesia: [],
    endometrium_pattern: [],
    ultrasound_method: [],
    catheter: [],
    embryoDifficulty_level: [],
    Laparo_anesthesia_type: [],
    adhesion_grade: [],
    endometriosis_grade: [],
    uterus_status: [],
    uterus_size: [],
    uterus_mobility: [],
    associated_procedures: [],
    liver_undersurface: [],
    cavity: [],
    endometrium_patterns: [],
    procedure_done: [],

  });

  const handleDatafromHeader = useCallback((data: PatientData) => {
    setSelectedPatient((prev) => {
      // Set if patient is not set or patient id is different
      if (!prev || prev.id !== data.id) {
        return data;
      }
      return prev;
    });
  }, []);
  // Navigate centrally based on a procedure type
  const redirectToProcedure = useCallback((procedureType: string) => {
    if (!selectedPatient) return;
    navigate(`/clinical/patients/surgery/${patientId}?surgeryType=${procedureType}`);
  }, [navigate, patientId, selectedPatient]);

  const determineProcedureOnQuery = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    const surgeryType = searchParams.get('surgeryType');

    if (!selectedPatient) return;

    if (!surgeryType) {
      if (selectedPatient.gender === 'MALE') {
        setSelectedProcedure('SpermRetrieval');
        redirectToProcedure('SpermRetrieval');
      } else if (selectedPatient.gender === 'FEMALE') {
        setSelectedProcedure('OocyteRetrieval');
        redirectToProcedure('OocyteRetrieval');
      }
      return;
    }

    if (selectedPatient) {
      if (selectedPatient.gender === 'MALE') {
        setSelectedProcedure('SpermRetrieval');
        redirectToProcedure('SpermRetrieval');
      } else if (selectedPatient.gender === 'FEMALE') {
        if (surgeryType === 'SpermRetrieval') {
          setSelectedProcedure('OocyteRetrieval');
          redirectToProcedure('OocyteRetrieval');
        } else {
          setSelectedProcedure(surgeryType);
          redirectToProcedure(surgeryType);
        }
      }
    }
  }, [location.search, selectedPatient, redirectToProcedure]);

  useEffect(() => {
    fetchMasterData(
      '' // type wise not filtering from API
    )
      .then((response) => {
        setDropdownOptionsForSurgery({
          type_of_anesthesia: mapDropdownOptions(response?.OOCYTE_ANESTHESIA),
          type_of_needle: mapDropdownOptions(response?.NEEDLE),
          sub_type_of_needle: mapDropdownOptions(response?.NEEDLE_SUBTYPE),
          difficulty_level: mapDropdownOptions(response?.DIFFICULTY),
          transfer_method: mapDropdownOptions(response?.TRANSFER_METHOD),
          embryo_Anesthesia: mapDropdownOptions(response?.EMBRYO_ANESTHESIA),
          endometrium_pattern: mapDropdownOptions(response?.EEMBRYO_NDOMETRIUM_PATTERN),
          ultrasound_method: mapDropdownOptions(response?.ULTRASOUND_METHOD),
          catheter: mapDropdownOptions(response?.CATHETER),
          embryoDifficulty_level: mapDropdownOptions(response?.LEVEL_OF_DIFFICULTY),
          Laparo_anesthesia_type: mapDropdownOptions(response?.LAPARO_ANESTHESIA),
          adhesion_grade: mapDropdownOptions(response?.ADHESION_GRADE),
          endometriosis_grade: mapDropdownOptions(response?.ENDOMETRIOSIS_GRADE),
          uterus_status: mapDropdownOptions(response?.UTERUS_STATUS),
          uterus_size: mapDropdownOptions(response?.UTERUS_SIZE),
          uterus_mobility: mapDropdownOptions(response?.UTERUS_MOBILITY),
          associated_procedures: mapDropdownOptions(response?.ASSOCIATED_PROCEDURES),
          liver_undersurface: mapDropdownOptions(response?.LIVER_STATUS),
          cavity: mapDropdownOptions(response?.CAVITY),
          endometrium_patterns: mapDropdownOptions(response?.ENDOMETRIUM_PATTERN),
          procedure_done: mapDropdownOptions(response?.PROCEDURE_DONE),



        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Error fetching medical history masters', err);
      });
  }, []);

  useEffect(() => {
    determineProcedureOnQuery();
  }, [location.search, selectedPatient, determineProcedureOnQuery]);
  const handleProcedureSelect = useCallback((procedure: string) => {
    setSelectedProcedure(procedure);
    redirectToProcedure(procedure);
  }, [redirectToProcedure]);

  useEffect(() => {
    showLoader();
    setCycleExists(false); // Reset initially

    getARTCycleList(selected_PID)
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setCycleExists(true);
        } else {
          setCycleExists(false);
        }
      })
      .catch(() => {
        setCycleExists(false);
      })
      .finally(() => {
        hideLoader();
      });
  }, [selected_PID, selectedPatient, showLoader, hideLoader]);


  const renderProcedureForm = useMemo(() => {
    if (!selectedPatient) return <p>No patient selected</p>;

    if (!cycleExists && ['OocyteRetrieval', 'EmbryoTransfer'].includes(selectedProcedure)) {
      return <CyclesUnavailable />;
    }

    switch (selectedProcedure) {
    case 'OocyteRetrieval':
      return <OocyteRetrieval dropDownOptions={dropdownOptionsForSurgery} />;
    case 'EmbryoTransfer':
      return <EmbryoTransfer dropDownOptions={dropdownOptionsForSurgery} />;
    case 'Laparoscopy':
      return <LaparoscopyContainer dropDownOptions={dropdownOptionsForSurgery} />;
    case 'Hysteroscopy':
      return <HystereoscopyContainer dropDownOptions={dropdownOptionsForSurgery}/>;
    case 'SpermRetrieval':
      return <SurgicalSpermRetrievalContainer />;
    default:
      return <p>Please select a procedure</p>;
    }
  }, [selectedPatient, selectedProcedure, cycleExists,dropdownOptionsForSurgery]);

  const procedures = useMemo(() => {
    if (!selectedPatient) return [];
    return selectedPatient.gender === 'MALE'
      ? [{ name: 'SpermRetrieval', label: 'Surgical Sperm Retrieval', icon: <SpermRetrievalIcon /> }]
      : [
        { name: 'OocyteRetrieval', label: 'Oocyte Retrieval', icon: <UterusIcon /> },
        { name: 'EmbryoTransfer', label: 'Embryo Transfer', icon: <EmbryoIcon /> },
        { name: 'Laparoscopy', label: 'Laparoscopy', icon: <LaparoscopyIcon /> },
        { name: 'Hysteroscopy', label: 'Hysteroscopy', icon: <HysteroscopyIcon /> }
      ];
  }, [selectedPatient]);

  const borderAnimation = keyframes`
  0% {
    border-color: rgba(235, 235, 235, 1);
    border-width: 1px;
    box-shadow: 0 0 3px rgba(255, 126, 0, 0.8), 0 0 10px rgba(255, 126, 0, 0.6);
  }
`;


  const buttonStyles = useMemo(() => ({
    base: {
      border: '1px solid rgba(235, 235, 235, 1)',
      backgroundColor: 'rgba(250, 250, 250, 1)',
      boxShadow: 'none',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      color: 'rgba(193, 193, 193, 1)',
      '&:hover': {
        backgroundColor: 'rgba(255, 248, 246, 1)',
        boxShadow: '2px 2px 12px 0px rgba(0, 0, 0, 0.15)',
      }
    },
    selected: {
      border: '1px solid rgba(225, 126, 97, 1)',
      backgroundColor: 'rgba(255, 248, 246, 1)',
      boxShadow: '2px 2px 8px 0px rgba(0, 0, 0, 0.12)',
      color: 'rgba(225, 126, 97, 1)',
      fontWeight: 600,
      animation: `${borderAnimation} 5s ease-in-out `,
    }
  }), [borderAnimation]);


  return (
    <ThemeProvider theme={theme}>
      <div>
        <HeaderProfile onData={handleDatafromHeader} />

        {/* Render buttons dynamically */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 4,
            marginLeft: 3,
            marginRight: 3, // Add marginRight for spacing on the right
          }}
        >
          {/* Left side: dynamically rendered buttons */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            {procedures.map((procedure) => (
              <Button
                key={procedure.name}
                variant="contained"
                onClick={() => handleProcedureSelect(procedure.name)}
                sx={{
                  ...buttonStyles.base,
                  ...(selectedProcedure === procedure.name && buttonStyles.selected),
                }}
                startIcon={procedure.icon}
              >
                {procedure.label}
              </Button>
            ))}
          </Box>

          {/* Right side: print button */}
          {(selectedProcedure === 'OocyteRetrieval' || selectedProcedure === 'EmbryoTransfer') && (
            <PrintButton onClick={() => setOpenPreview(true)} />
          )}

        </Box>

        {selectedProcedure === 'OocyteRetrieval' && (
          <OocyteRetrievalPDFDialog
            open={openPreview}
            onClose={() => setOpenPreview(false)}
          />
        )}

        {selectedProcedure === 'EmbryoTransfer' && (
          <EmbryoTransferPDFDialog
            open={openPreview}
            onClose={() => setOpenPreview(false)}
          />
        )}

        <div style={{ marginTop: '2rem', marginLeft: '2rem' }}>
          {renderProcedureForm}
        </div>
      </div>
    </ThemeProvider>
  );
};

export default SurgeryPage;
